import { render, staticRenderFns } from "./CTABlock.vue?vue&type=template&id=717c715f&"
import script from "./CTABlock.vue?vue&type=script&lang=js&"
export * from "./CTABlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports